/* eslint-disable no-unused-vars */

jQuery(document).ready(function ($) {


    // Include Menus
    require('./menus/mobile-menu.js')
    require('./menus/desktop-menu.js')
    require('./menus/sidebar-menu.js')




   // Sticky Elements
    var mobileElementToSticky = '#top-bar-mobile';
    var desktopElementToSticky = '#header-desktop';

    $(window).scroll(function () {

        var distanceFromTop = $(this).scrollTop();
        if (distanceFromTop >= 0) {
            $(mobileElementToSticky, desktopElementToSticky).addClass('stuck-to-top');
            $('body').addClass('has-stuck-to-top');
        } else {
            $(mobileElementToSticky, desktopElementToSticky).removeClass('stuck-to-top');
            $('body').removeClass('has-stuck-to-top');
        }

    });

});


/* ===========================  Include Site Specific JS  ========================== */
/* eslint-disable no-unused-vars */
require('../site-scripts/child-app.js');
